import React from 'react';

class Enums extends React.Component {
    // it's a column formatter for exporting

    static smsFeatureName = "SMS Notify"
    static autoCallFeatureName = "Automated Call"
    static autoFillFeatureName = "Auto Fill"
}

export default Enums;


// WEBPACK FOOTER //
// ./src/common/Enums.js